module.exports = __webpack_public_path__ + "img/6.f41f56f0.png";